import * as api from "../shared/api";
import apiPath from "../shared/apiPath";
import * as biz_data_helper from "../shared/biz_data_helper";

const content_type = "";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = {
  default: [
    {
      key: "idx",
      label: "编号",
      sortable: true,
      thStyle: { display: "none" }
    },
    { key: 'fileName', label: '名称', sortable: true },
    { key: 'size_format', label: '大小(KB)', sortable: true },
    { key: 'description', label: '备注', sortable: true },
    { key: 'queryString', label: '链接', sortable: true, thStyle: { display: "none" } },
    { key: 'category', label: '类别', sortable: true, thStyle: { display: "none" } },
    { key: 'code', label: '编码', sortable: true, thStyle: { display: "none" } },
    { key: 'uploadBy', label: '创建人', sortable: true, width: "100" },
    { key: 'uploadAt', label: '创建时间', sortable: true, type: "datetime", width: "140" },
  ]
};

const dataForm = {};
const rules = {};
const methods = {
  //#region 上传
  async uploadToAzure(params) {
    let _p = new FormData();
    _p.append("category", params.category);
    _p.append("code", params.code);
    _p.append("files", params.files);
    let result = await api.query_async({
      url: apiPath.file.upload,
      parameters: _p,
      method: "post"
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  async updateDescription(params) {
    let _p = new FormData();
    _p.append("idx", params.idx);
    _p.append("description", params.description);
    let result = await api.query_async({
      url: apiPath.file.update,
      parameters: _p,
      method: "post"
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  async deleteFromAzure(params) {
    let _p = new FormData();
    _p.append("category", params.category);
    _p.append("code", params.code);
    _p.append("idx", params.idx);
    _p.append("fileName", params.fileName);
    let result = await api.query_async({
      url: apiPath.file.delete,
      parameters: _p,
      method: "post"
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  async downLoadFromAzure(params) {
    let result = await api.downloadFile({
      url: apiPath.file.downLoad + "?" + params.queryString,
      fileName: params.fileName
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  ///检查文件删除状态
  async getFileDeleteState(params) {
    const _biz_data = new biz_data_helper.base_entity_helper(
      "check_file_delete_state",
      {},
      {}
    );
    let result = await _biz_data
      .execAction({
        params: params
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async uploadFiles(params) {
    let _p = new FormData();
    _p.append("category", params.category);
    _p.append("code", params.code);
    _p.append("files", params.files);
    let result = await api.query_async({
      url: apiPath.file.upload_file,
      parameters: _p,
      method: "post"
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  async uploadDelete(params) {
    let _p = new FormData();
    _p.append("category", params.category);
    _p.append("code", params.code);
    _p.append("idx", params.idx);
    _p.append("fileName", params.fileName);
    let result = await api.query_async({
      url: apiPath.file.upload_delete,
      parameters: _p,
      method: "post"
    });
    if (result && result[0] && result[0].result && result[0].result.data) {
      return result[0].result.data;
    } else {
      return null;
    }
  },
  //#endregion
};
export { biz_data, dataForm, fields, methods, rules };

